import { styled } from 'stitches.config'

export const ArticleRoot = styled('article', {
  width: '100%',
  display: 'block',
  py: '$5',
  px: '$2',

  '@bp2': {
    py: '$6',
    px: '$4',
  },

  variants: {
    background: {
      tertiary: {
        backgroundColor: '$tertiary-200',
      },
      secondary: {
        backgroundColor: '$secondary-500',
      },
      white: {
        backgroundColor: '$accent-white',
      },
      primary: {
        backgroundColor: '$primary-700'
      },
      transparent: {
        backgroundColor: 'transparent',
      }
    },
  },
})

export const ArticleContainer = styled('div', {
  width: '100%',
  maxWidth: '900px',
  margin: '0 auto',
})
